import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import "./AdminNavbar.css"
import SearchIcon from '@mui/icons-material/Search';
import DehazeIcon from '@mui/icons-material/Dehaze';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useStateValue } from '../../StateProvider';
import { auth, db } from '../../firebase';
import Skwhite from '../../Skwhite.jpeg'
import { Modal } from 'react-bootstrap';
import swal from 'sweetalert';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import axios from "../../axios"
function AdminNavbar() {
  const history = useHistory()
  const [{ user }, dispatch] = useStateValue();
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState('')
  const submitSearch = (e) => {

    e.preventDefault();
    if (searchText === '') {
      swal("", "Please type some words to search", "error")
    } else {
      dispatch({
        type: "ADMIN_SEARCH_LOADING",
        payload: true
      })
      dispatch({
        type: "ADMIN_SEARCH_PRODUCTS",
        payload: []
      })
      axios({
        method: 'post',
        url: `/products/search/product`,
        data: { searchText: searchText }
      })
        .then(res => {
          dispatch({
            type: 'ADMIN_SEARCH_PRODUCTS',
            payload: res.data
          })
          dispatch({
            type: "ADMIN_SEARCH_LOADING",
            payload: false
          })
        })
        .catch(err => console.log(err))
    }
  }

  useEffect(() => {
    if (user) {
      db.collection('register')
        .doc(user.uid)
        .get().then((doc) => {
        }).catch((err) => {
          console.log(err)
        })
    }

  }, [user])

  const login = () => {
    if (user) {
      auth.signOut();
      history.push('/')
    }
  }
  const close = () => {
    setShowModal(false)
  }

  return (
    <>
      <nav className="header" id="#top">
        <Modal className='modal__position'
          show={showModal}
          onHide={() => {
            setShowModal(false);
          }}
        >
          <Modal.Header style={{ backgroundColor: '#000000' }}>
            <Modal.Title>
              <ul className="navbar-nav">
                <CloseRoundedIcon onClick={close} className='header__close' />
                {user ?
                  <Link className='text-decoration-none header__link' onClick={close} to='/profile'>
                    <li >
                      <h5 className='text-white mt-1 text-center'>View Profile</h5>
                      <h6 className="t mt-3 ml-1 text-white text-center"><span><AccountCircleIcon /></span>   Hello, {user ? user.email : ' Guest'}</h6>
                    </li>
                  </Link>
                  :
                  <li>
                    <h6 className="t mt-3 ml-1 text-white text-center"><span><AccountCircleIcon /></span>   Hello, {user ? user.email : ' Guest'}</h6>
                  </li>
                }
              </ul>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ul className="navbar-nav">
              <Link to={`${user ? '' : '/login'}`} className="header__link text-dark text-decoration-none align-self-start">
                <li className='mb-2'>
                  <span className="t mt-3 category " onClick={login}>{user ? 'Sign out' : 'Sign in'}</span>
                </li>
              </Link>
              <Link to="/admin/orders" className="header__link text-dark text-decoration-none align-self-start" >
                <div className="header__option ml-3 mb-1 category">
                  <span onClick={close}>Returns & orders</span>
                </div>
              </Link>
              <Link to="/admin" className="header__link text-dark text-decoration-none align-self-start" >
                <div className="header__option ml-3 mb-1 category">
                  <span onClick={close}>Dashboard</span>
                </div>
              </Link>
            </ul>
          </Modal.Body>
        </Modal>
        <span className='ml-3 text-white'>
          <DehazeIcon style={{ fontSize: '28px' }} onClick={() => { setShowModal(true) }} />
        </span>

        <Link to="/" className="dvv">
          <img width='5px' height='40px' className="admin__header__logo" src={Skwhite} alt="logo" ></img>
        </Link>
        <form onSubmit={submitSearch} className="header__search">
          <input placeholder='Search' className='pl-3 w-100' type='text' onChange={(e) => { setSearchText(e.target.value) }} />
          <SearchIcon onClick={submitSearch} className='header__searchIcon' />
        </form>
        <div className="header__nav">
          <Link to={`${user ? '' : '/login'}`} className="header__link text-decoration-none" id='signorder1'>
            <div onClick={login} className="header__option">
              <span className="header__optionLineOne">Hello, {!user ? "Guest" : user.email}</span>
              <span className="header__optionLineTwo so">{user ? 'sign out' : 'sign in'}</span>
            </div>
          </Link>
          <Link to="/admin/orders" className="header__link text-decoration-none" id='signorder2'>
            <div className="header__option">
              <span className="header__optionLineTwo mt-1">orders</span>
            </div>
          </Link>
        </div>
      </nav>
      <nav className="search2">
        <form onSubmit={submitSearch} className="header__search2">
          <input placeholder='Search . . .' className='p-3 dropdown_list header__searchInput2' onChange={(e) => { setSearchText(e.target.value) }} />
          <SearchIcon onClick={submitSearch} className='header__searchIcon2' />
        </form>
      </nav>
    </>


  );
}

export default AdminNavbar;
